import { Command } from '@/app/common/base/command'

export class UpdateDateConditionPrecedentCommand extends Command {
    public async run(productActionId: string, dateConditionsPrecedent: string) {
        await this.client.post(`/api/products/mortgages/actions/${productActionId}/date-conditions-precedent`, {
            dateConditionsPrecedent
        })
    }
}
